import { Box, styled } from '@mui/material';
import { Swiper } from 'swiper/react';

export const NewsContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.colors.newsBackground,
  width: 'calc(100vw - 32px)',
  height: '160px',
  padding: '16px 16px 0',
  border: `1px solid ${theme.palette.colors.borderLine}`,
  borderRadius: '12px',

  '& .swiper-wrapper': {
    height: 'auto',
  },
  '& .swiper-pagination-bullet-active': {
    color: theme.palette.colors.highlight,
    '--swiper-theme-color': theme.palette.colors.highlight,
  },
  marginBottom: '16px',
  alignSelf: 'center',

  [theme.breakpoints.up('sm')]: {
    width: 'calc(100vw - 64px)',
  },
  [theme.breakpoints.up('md')]: {
    width: 'calc(100vw - 96px)',
  },
  [theme.breakpoints.up('lg')]: {
    width: '34.25%',
    height: '392px',
    padding: '20px 17px 10px',
    borderRadius: '5px',
    marginBottom: '18px',
    order: 1,
  },
}));

export const SwiperStyled = styled(Swiper)(({ theme }) => ({
  height: '141px',
  width: '100%',

  [theme.breakpoints.up('lg')]: {
    height: '310px',
  },
}));
